export { default } from './MerchModuleWrapper'
